<template>
  <div id="app">
    <nprogress-container />
    <component :is="layout">
      <router-view :key="$route.path" />
    </component>
  </div>
</template>

<script>
  import NprogressContainer from 'vue-nprogress/src/NprogressContainer';
  import referrals from "@/snippets/referrals";

  const default_layout = "default";
  const logo = process.env.VUE_APP_NAME === "Planetajob" ? "planetajob_logo_dark.png" : "aicad_logo_dark.png";

  export default {
    components: {
      NprogressContainer
    },

    computed: {
      layout() {
        return (this.$route.meta.layout || default_layout) + '-layout';
      },
    },

    created() {
      // REFERRALS: Save ?ref= value into session of the client
      referrals.save(this.$route.query.ref);
    },

    metaInfo: {
      title: 'Ofertas de empleo',
      titleTemplate: '%s - ' + process.env.VUE_APP_NAME,
      meta: [
        { vmid: "description", name: "description", content: "PlanetaJob description" },
        { vmid: "og:title", name: "og:title", content: process.env.VUE_APP_NAME },
        { vmid: "og:description", name: "og:description", content: process.env.VUE_APP_NAME  + " description" },
        { vmid: "og:image", name: "og:image", content: `${process.env.VUE_APP_PUBLIC_URL}/${logo}` },
        { vmid: "og:url", name: "og:url", content: window.location.href },
        { vmid: "twitter:card", name: "twitter:card", content: "summary_large_image" },
      ],
    }
  }
</script>

<style lang="scss">
@import "assets/scss/main.scss";
</style>
